import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripe_public_dev =
  "pk_test_51QanrsBDcinsz2JPitKLJPTxh1EW9Ya3fVCGTWzZ2eaA4hQdZpDw7EgXiBspOozygzu9HxtoMUGt95FUaawppmqH00TXbU6yEA";

const stripe_public_prod =
  "pk_live_51QanrsBDcinsz2JPknHagtrK2Sv3fpXt28ouvbkku7edHzJHy89Zc0YJveFppT7cBIGxUUcSqyx2IEuQKXE1qauH001MOMYGUm";

// Load Stripe with your public key
const stripePromise = loadStripe(stripe_public_prod);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </React.StrictMode>
);
